import * as React from 'react'
import { FormikProps } from 'formik'
import { FormikTextField, FormikSelect } from 'components'
import { Grid } from 'cs-kevlar-react'
import * as Yup from 'yup'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { Customer, CustomerSummary } from 'contexts/base'
import { getAllCustomerProductLines, getAllConnectorTypes } from 'utils'

interface EditCustomerFormProps {
  formikProps: FormikProps<Customer | CustomerSummary>
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridItem: {
      width: '100%',
    },
  }),
)

export const EditCustomerFormSchema = Yup.object().shape({
  name: Yup.string().required('The Customer field is required.'),
  productLine: Yup.string()
    .required('The Product Line field is required.')
    .matches(/^(?!0$).*/, 'The Product Line field is required.'),
  connectorType: Yup.string()
    .required('The Connector Type field is required.')
    .matches(/^(?!0$).*/, 'The Connector Type field is required.'),
  notes: Yup.string(),
})

const ProductLineOptions = getAllCustomerProductLines()

const ConnectorTypeOptions = getAllConnectorTypes()

export const EditCustomerForm: React.FunctionComponent<EditCustomerFormProps> = ({
  formikProps,
}) => {
  const classes = useStyles({})

  return (
    <React.Fragment>
      <Grid item className={classes.gridItem}>
        <FormikTextField
          formikProps={formikProps}
          fieldName="name"
          label="Customer"
          fullWidth
          required
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <FormikSelect
          id="EditCustomer::ProductLine"
          formikProps={formikProps}
          label="Product Line"
          fieldName="productLine"
          fullWidth
          options={ProductLineOptions}
          required
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <FormikSelect
          id="EditCustomer::ConnectorType"
          formikProps={formikProps}
          label="Connector Type"
          fieldName="connectorType"
          fullWidth
          options={ConnectorTypeOptions}
          required
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <FormikTextField
          formikProps={formikProps}
          fieldName="notes"
          label="Notes"
          fullWidth
          multiline
          rows={5}
        />
      </Grid>
      {formikProps.values.id !== 'NEW' && (
        <FormikTextField
          formikProps={formikProps}
          fieldName="databaseShardId"
          label="Shard"
          fullWidth
          readOnly
        />
      )}
    </React.Fragment>
  )
}
